module.exports = __webpack_public_path__ + "img/7fc897f59da72fcd2696a668e5414eb0.svg";